import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const ItemType = "INITIATIVE";

const DraggableInitiative = ({
  index,
  initiative,
  moveInitiative,
  children
}) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    hover(item) {
      if (item.index === index) return;

      moveInitiative(item.index, index);
      item.index = index;
    }
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{ opacity: isDragging ? 0.5 : 1, cursor: "move" }}
      className="initiative-header"
    >
      {children}
    </div>
  );
};

export default DraggableInitiative;
